<div class="card mb-4">
  <div class="card-body pb-5">
    <div class="d-flex justify-content-between flex-row flex-wrap gap-3 mb-4">
      <div class="card-title mb-0 d-flex align-items-center">
        <h4 class="mb-0">Addresses</h4>
      </div>
      <button type="button" class="btn btn-primary" (click)="openAddressForm()">
        <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.9" class="d-none d-sm-inline" />
        Add / Edit
      </button>
    </div>

    @if (!hasAddresses()) {
      <div class="text-center text-muted py-4">
        <fa-duotone-icon icon="location-dot" secondaryOpacity="0.3" class="fs-1 d-block mb-2"></fa-duotone-icon>
        <p class="mb-1">{{ OrganizationsMessagingConstants.ORGANIZATIONS_NO_ADDRESSES_TITLE() }}</p>
        <p class="small mb-0">{{ OrganizationsMessagingConstants.ORGANIZATIONS_NO_ADDRESSES_HELP() }}</p>
      </div>
    } @else {
      <div class="d-flex flex-column gap-3">
        @for (address of addresses(); track address.addressId) {
          <div class="border rounded-3 px-3 py-2 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="list-row-icon me-4">
                <fa-duotone-icon [icon]="addressTypeIcon(address.addressType)" secondaryOpacity="0.5" class="fs-1 text-primary"></fa-duotone-icon>
              </div>
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ address.addressType }}</span>
                <small class="text-muted" [innerHTML]="address | Address: AddressPipeSecondaryAddressFormat.NewLine"></small>
              </div>
            </div>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="openRemoveConfirmation(address)">
              Remove
            </button>
          </div>
        }
      </div>
    }
  </div>
</div>

<ms-organization-address-form-modal
  #addressFormModal
  [organization]="organization()"
  (addressSaved)="onAddressSaved($event)"
  (addressSaveFailed)="onAddressSaveFailed($event)">
</ms-organization-address-form-modal>

<ms-confirmation-modal
  #removeAddressModal
  modalId="removeAddressModal"
  confirmButtonText="Remove"
  cancelButtonText="Cancel"
  confirmButtonClassName="btn-danger"
  (confirmed)="confirmRemoveAddress()"
  (cancelled)="cancelRemoveAddress()"
  [isSubmitting]="isSubmitting()">
</ms-confirmation-modal>

<ms-info-modal
  #addressInfoModal
  modalId="addressInfoModal"
  (onConfirm)="closeInfoModal()">
</ms-info-modal>
